import { options_premium_TransferDomainContent_part1 } from './DomainTransferOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { getUserConfiguration } from 'owa-session-store';
import { HMPlusBit } from 'owa-domain-connect';
import getGoDaddyDomainDetailsAction from './orchestrators/getGoDaddyDomainDetails';
import { isFeatureEnabled } from 'owa-feature-flags';

var lazyFullModule = new LazyModule(() => import('./lazyDomainTransferOption'));
let DomainTransferOption: LazyOption = createLazyOption(
    {
        key: 'domainTransferPageText1',
        titleStringKey: options_premium_TransferDomainContent_part1,
        searchTermsStringKey: options_premium_TransferDomainContent_part1,
        hideTitleInFullOptions: false,
        isHidden: () =>
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
            !isFeatureEnabled('auth-PremiumTransferDomainTab') ||
            !getGoDaddyDomainDetailsAction(null) ||
            (getUserConfiguration().SessionSettings.PremiumAccountOffers & HMPlusBit) !== HMPlusBit,
    },
    lazyFullModule,
    m => m.default
);
export default DomainTransferOption;
